import React from 'react';
import { Button, Modal, ModalFooter, ModalBody, ModalHeader, Row, Label } from 'reactstrap';

class ConfirmationModal extends React.Component {

    //This is made to be a generic confirmation modal. It takes the following props:  isOpen, onToggle, onConfirm, modalHeader, modalBody

    handleConfirm = () => {
        const { onConfirm, onToggle } = this.props;
        onToggle();
        onConfirm();
    }

    render() {
        return (
            <Modal
                isOpen={this.props.isOpen}
                toggle={this.props.onToggle}
                size='lg'
            >
                <ModalHeader>{this.props.modalHeader}</ModalHeader>
                <ModalBody>
                    <Row>
                        <Label>{this.props.modalBody}</Label>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={this.handleConfirm}>OK</Button>{' '}
                    <Button color="secondary" onClick={this.props.onToggle}>Cancel</Button>
                </ModalFooter>
            </Modal>
        )
    }
}

export default ConfirmationModal